import { ParticleAIAssistant } from './widget/ParticleAIAssistant';
import { BackendAdapter, LocalMockAdapter } from './ai/AIAdapter';
import { AssistantPanel } from './widget/AssistantPanel';
import { SpeechController } from './voice/SpeechController';
import { LipSyncController } from './voice/LipSyncController';
import { NebulaBackground } from './particles/NebulaBackground';
import { CosmicDustBackground } from './particles/CosmicDustBackground';
Object.assign(window, { ParticleAIAssistant, Razum: { ParticleAIAssistant, AssistantPanel, BackendAdapter, LocalMockAdapter, SpeechController, LipSyncController, NebulaBackground, CosmicDustBackground } });
